module.exports = __webpack_public_path__ + "img/schoolShield_icon.ab96e081.png";